import getConfig from 'next/config';

import { CONSTRUCTOR_SERVICE_URL } from 'search/enums/constants';
import { requestService } from 'shared/utils/services/requestService';

export const getListingsCount = async () => {
  return requestService({
    url: `/web-api/consumer-search/get-listings-count`,
    method: 'GET',
  });
};

export const getListingsCountFromConstructor = async () => {
  const {
    publicRuntimeConfig: { CONSTRUCTOR_API_KEY },
  }: { publicRuntimeConfig: { CONSTRUCTOR_API_KEY: string } } = getConfig();

  return requestService({
    url: `${CONSTRUCTOR_SERVICE_URL}/browse/groups?filters[group_id]=all&key=${CONSTRUCTOR_API_KEY}`,
    method: 'GET',
  });
};
